import * as Ee from "@arcgis/core/geometry/operators/unionOperator";
import { createLogger as le } from "@origo/logger";
import * as Fe from "@arcgis/core/geometry/operators/areaOperator";
import * as Oe from "@arcgis/core/geometry/operators/intersectionOperator";
import * as Ie from "@arcgis/core/geometry/operators/intersectsOperator";
import Se from "@arcgis/core/layers/support/CodedValueDomain";
import pe from "@arcgis/core/request";
import ve from "@arcgis/core/rest/support/FeatureSet";
import Pe from "@arcgis/core/layers/FeatureLayer";
import { queryOptions as I, useQuery as S } from "@tanstack/react-query";
import { jsx as Te } from "react/jsx-runtime";
import { createContext as he, useMemo as Be, useContext as ue } from "react";
function fe(e) {
  return e.replace(/_VN\d+$/, "");
}
function x(e) {
  return e.planomrader ? e.planomrader : e.objectId == null ? [] : [
    {
      planTypeKey: e.planTypeKey,
      objectId: e.objectId,
      vertNiv: e.vertNiv,
      vertNivDisplay: e.displayValues?.vertNiv
    }
  ];
}
function je(e) {
  const r = x(e).map((n) => n.planTypeKey);
  return r.length > 0 ? [...new Set(r)] : [e.planTypeKey];
}
function ge(e) {
  const r = /* @__PURE__ */ new Map(), n = [];
  for (const t of e) {
    if (!t.planId) {
      n.push(t);
      continue;
    }
    const o = `${fe(t.planTypeKey)}|${t.planStat ?? ""}|${t.planId}`, a = r.get(o);
    a ? a.push(t) : (r.set(o, [t]), n.push(o));
  }
  return n.map(
    (t) => typeof t == "string" ? we(r.get(t)) : t
  );
}
const Ke = "2", Le = (e) => /_VN(\d+)$/.exec(e.planTypeKey)?.[1] ?? e.vertNiv, Me = (e, r) => e.planTypeKey.localeCompare(r.planTypeKey) || e.objectId - r.objectId;
function we(e) {
  const r = /* @__PURE__ */ new Map();
  for (const a of e.flatMap(x))
    r.set(`${a.planTypeKey}:${a.objectId}`, a);
  const n = [...r.values()].sort(Me);
  if (e.length === 1)
    return n.length > 0 ? { ...e[0], planomrader: n } : e[0];
  const t = n.find((a) => Le(a) === Ke) ?? n[0];
  return { ...t && e.find(
    (a) => a.planTypeKey === t.planTypeKey && x(a).some((i) => i.objectId === t.objectId)
  ) || e[0], planomrader: n };
}
function De(e) {
  return e.planId ? `${fe(e.planTypeKey)}-${e.planStat ?? ""}-${e.planId}` : `${e.planTypeKey}-${e.planStat ?? ""}-${e.vertNiv ?? ""}--oid:${e.objectId ?? ""}`;
}
class w extends Error {
  constructor(r, n) {
    super(r), this.cause = n, this.name = this.constructor.name;
  }
}
class Ge extends w {
  constructor(r, n) {
    super(`${r} ikke funnet: ${n}`);
  }
}
class $e extends w {
}
class U extends w {
}
class xe extends w {
}
class Q extends w {
  constructor() {
    super("Operasjonen ble avbrutt");
  }
}
class z extends w {
}
const Kr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortedError: Q,
  ArealplanError: w,
  AuthError: xe,
  ConfigurationError: z,
  NetworkError: U,
  NotFoundError: Ge,
  ValidationError: $e,
  mergePlanomrader: ge,
  planKey: De,
  planTypeKeysFor: je,
  planomraderFor: x
}, Symbol.toStringTag, { value: "Module" })), de = {
  minRatio: 0.01,
  minAreaM2: 1 / 0
};
function re(e) {
  try {
    return Math.abs(Fe.execute(e, { unit: "square-meters" }));
  } catch {
    return 0;
  }
}
function ke(e, r, n = {}) {
  if (!e || !r)
    return { keep: !0, reason: "missing-geometry" };
  const t = n.minAreaM2 ?? de.minAreaM2, o = n.minRatio ?? de.minRatio, a = e.spatialReference?.wkid, i = r.spatialReference?.wkid;
  if (a != null && i != null && a !== i)
    return { keep: !0, reason: "sr-mismatch", srcWkid: a, candWkid: i };
  const s = e, R = r;
  try {
    if (!Ie.execute(s, R))
      return { keep: !1, reason: "no-intersect", srcWkid: a, candWkid: i };
  } catch {
    return { keep: !0, reason: "intersect-error", srcWkid: a, candWkid: i };
  }
  let g;
  try {
    g = Oe.execute(s, R);
  } catch {
    return { keep: !0, reason: "intersection-error", srcWkid: a, candWkid: i };
  }
  if (!g)
    return a != null && i != null && a === i ? { keep: !1, reason: "touch-no-area", srcWkid: a, candWkid: i, overlapAreaM2: 0, ratio: 0 } : { keep: !0, reason: "intersection-null", srcWkid: a, candWkid: i };
  const D = re(g), h = re(e), B = re(r), _ = Math.min(h, B), Z = _ > 0 ? D / _ : 0, J = { srcWkid: a, candWkid: i, overlapAreaM2: D, sourceAreaM2: h, candidateAreaM2: B, ratio: Z };
  return Z >= o ? { keep: !0, reason: "ratio-pass", ...J } : D >= t ? { keep: !0, reason: "area-pass", ...J } : { keep: !1, reason: "below-threshold", ...J };
}
function me(e, r, n = {}) {
  return ke(e, r, n).keep;
}
const _e = /^(Kommuneplan|Kommunedelplan|Reguleringsplan|Bebyggelsesplan)/i, Ve = /^Dispensasjon/i, qe = /^PblMidlForbud/i, oe = {
  // Reguleringsplan (Rp-prefiks) — arealformål
  RpArealformålOmråde: {
    canonical: "RpArealformålOmråde",
    aliases: ["RpArealformålOmråde", "RpArealformalOmrade", "RpArealformaalOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "RPAREALFORMAL"
  },
  RpBestemmelseOmråde: {
    canonical: "RpBestemmelseOmråde",
    aliases: ["RpBestemmelseOmråde", "RpBestemmelseOmrade"],
    headingFelt: "BESTEMMELSEOMRNAVN",
    typeFelt: "RPBESTEMMELSEHJEMMEL"
  },
  RpAngittHensynSone: {
    canonical: "RpAngittHensynSone",
    aliases: ["RpAngittHensynSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPANGITTHENSYN"
  },
  RpBåndleggingSone: {
    canonical: "RpBåndleggingSone",
    aliases: ["RpBåndleggingSone", "RpBandleggingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPBANDLEGGING"
  },
  RpDetaljeringSone: {
    canonical: "RpDetaljeringSone",
    aliases: ["RpDetaljeringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPDETALJERING"
  },
  RpFareSone: {
    canonical: "RpFareSone",
    aliases: ["RpFareSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPFARE"
  },
  RpGjennomføringSone: {
    canonical: "RpGjennomføringSone",
    aliases: ["RpGjennomføringSone", "RpGjennomforingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPGJENNOMFORING"
  },
  RpInfrastrukturSone: {
    canonical: "RpInfrastrukturSone",
    aliases: ["RpInfrastrukturSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPINFRASTRUKTUR"
  },
  RpSikringSone: {
    canonical: "RpSikringSone",
    aliases: ["RpSikringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPSIKRING"
  },
  RpStøySone: {
    canonical: "RpStøySone",
    aliases: ["RpStøySone", "RpStoySone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPSTOY"
  },
  // Reguleringsplan/Bebyggelsesplan etter gammel lov (Rb-prefiks)
  RbArealbrukOmråde: {
    canonical: "RbArealbrukOmråde",
    aliases: ["RbArealbrukOmråde", "RbArealbrukOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbFormålOmråde: {
    canonical: "RbFormålOmråde",
    aliases: ["RbFormålOmråde", "RbFormalOmrade", "RbFormaalOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbBevaringOmråde: {
    canonical: "RbBevaringOmråde",
    aliases: ["RbBevaringOmråde", "RbBevaringOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbFareOmråde: {
    canonical: "RbFareOmråde",
    aliases: ["RbFareOmråde", "RbFareOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbFornyelseOmråde: {
    canonical: "RbFornyelseOmråde",
    aliases: ["RbFornyelseOmråde", "RbFornyelseOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbRekkefølgeOmråde: {
    canonical: "RbRekkefølgeOmråde",
    aliases: ["RbRekkefølgeOmråde", "RbRekkefolgeOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbRestriksjonOmråde: {
    canonical: "RbRestriksjonOmråde",
    aliases: ["RbRestriksjonOmråde", "RbRestriksjonOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  // Kommuneplan / Kommunedelplan (Kp-prefiks) — arealformål
  KpArealformålOmråde: {
    canonical: "KpArealformålOmråde",
    aliases: ["KpArealformålOmråde", "KpArealformalOmrade"],
    headingFelt: "OMRNAVN",
    typeFelt: "KPAREALFORMAL"
  },
  KpArealbrukOmråde: {
    canonical: "KpArealbrukOmråde",
    aliases: ["KpArealbrukOmråde", "KpArealbrukOmrade"],
    headingFelt: "OMRNAVN",
    typeFelt: "OPLAREAL"
  },
  KpBestemmelseOmråde: {
    canonical: "KpBestemmelseOmråde",
    aliases: ["KpBestemmelseOmråde", "KpBestemmelseOmrade"],
    headingFelt: "BESTEMMELSEOMRNAVN",
    typeFelt: "KPBESTEMMELSEHJEMMEL"
  },
  KpRestriksjonOmråde: {
    canonical: "KpRestriksjonOmråde",
    aliases: ["KpRestriksjonOmråde", "KpRestriksjonOmrade"],
    headingFelt: "OBJTYPE",
    typeFelt: "OPLRESTR"
  },
  KpRetningslinjeOmråde: {
    canonical: "KpRetningslinjeOmråde",
    aliases: ["KpRetningslinjeOmråde", "KpRetningslinjeOmrade"],
    headingFelt: "OBJTYPE",
    typeFelt: "OPLRETNL"
  },
  KpAngittHensynSone: {
    canonical: "KpAngittHensynSone",
    aliases: ["KpAngittHensynSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPANGITTHENSYN"
  },
  KpBåndleggingSone: {
    canonical: "KpBåndleggingSone",
    aliases: ["KpBåndleggingSone", "KpBandleggingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPBANDLEGGING"
  },
  KpDetaljeringSone: {
    canonical: "KpDetaljeringSone",
    aliases: ["KpDetaljeringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPDETALJERING"
  },
  KpFareSone: {
    canonical: "KpFareSone",
    aliases: ["KpFareSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPFARE"
  },
  KpGjennomføringSone: {
    canonical: "KpGjennomføringSone",
    aliases: ["KpGjennomføringSone", "KpGjennomforingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPGJENNOMFORING"
  },
  KpInfrastrukturSone: {
    canonical: "KpInfrastrukturSone",
    aliases: ["KpInfrastrukturSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPINFRASTRUKTUR"
  },
  KpSikringSone: {
    canonical: "KpSikringSone",
    aliases: ["KpSikringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPSIKRING"
  },
  KpStøySone: {
    canonical: "KpStøySone",
    aliases: ["KpStøySone", "KpStoySone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPSTOY"
  },
  // PBL midlertidig (Pbl-prefiks)
  PblMidlByggAnleggOmråde: {
    canonical: "PblMidlByggAnleggOmråde",
    aliases: ["PblMidlByggAnleggOmråde", "PblMidlByggAnleggOmrade"],
    headingFelt: "BESTEMMELSEOMRNAVN",
    typeFelt: "OBJTYPE"
  }
}, ne = Array.from(
  new Set(Object.values(oe).flatMap((e) => e.aliases))
);
function C(e) {
  if (!e)
    return;
  const r = oe[e];
  if (r)
    return r;
  for (const n of Object.values(oe))
    if (n.aliases.includes(e))
      return n;
}
const V = {
  Reguleringsplan: ["RpOmrade"],
  Bebyggelsesplan: ["RpOmrade"],
  Kommuneplan: ["KpOmrade"],
  Kommunedelplan: ["KpOmrade"],
  Dispensasjon: ["DispensasjonPunkt"],
  PblMidlForbud: ["PblMidlForbudMotTiltakFlate"]
};
function te(e) {
  if (V[e])
    return V[e];
  const r = e.replace(/(_UA)?(_VN\d+)?$/, "");
  if (V[r])
    return V[r];
  for (const [n, t] of Object.entries(V))
    if (e.includes(n))
      return t;
  return [];
}
const Ye = {
  PLANID: "planId",
  LOKALID: "lokalId",
  GlobalID: "globalId",
  OBJECTID: "objectId",
  PLANNAVN: "planNavn",
  PLANSTAT: "planStat",
  PLANTYPE: "planTypeKey",
  VERTNIV: "vertNiv",
  IKRAFT: "ikraft",
  BESKRIVELSE: "beskrivelse",
  KOMMUNENUMMER: "kommunenummer",
  PLANBEST: "planBestemmelser",
  LOVREFERANSE: "lovreferanse",
  PLANREGISTERLINK: "planRegisterLink"
};
function Ce(e) {
  const r = {};
  if (e)
    for (const [n, t] of Object.entries(e)) {
      const o = Ye[n];
      o && t != null && (r[o] = String(t));
    }
  return Object.keys(r).length > 0 ? r : void 0;
}
function ce(e, r, n) {
  const t = e.OBJECTID != null ? Number(e.OBJECTID) : void 0, o = e.VERTNIV ?? void 0, a = Ce(n);
  return {
    planId: String(e.PLANID ?? ""),
    lokalId: e.LOKALID ?? void 0,
    globalId: e.GlobalID ?? void 0,
    objectId: t,
    planomrader: t != null ? [{ planTypeKey: r, objectId: t, vertNiv: o, vertNivDisplay: a?.vertNiv }] : void 0,
    planTypeKey: r,
    planNavn: e.PLANNAVN ?? void 0,
    planStat: e.PLANSTAT ?? void 0,
    vertNiv: o,
    ikraft: e.IKRAFT ?? void 0,
    beskrivelse: e.BESKRIVELSE ?? void 0,
    kommunenummer: e.KOMMUNENUMMER ?? void 0,
    planBestemmelser: e.PLANBEST ?? void 0,
    lovreferanse: e.LOVREFERANSE ?? void 0,
    planRegisterLink: e.PLANREGISTERLINK ?? void 0,
    displayValues: a
  };
}
function Je(e, r) {
  if (typeof e.LOKALID == "string" && e.LOKALID.trim() !== "")
    return e.LOKALID.trim();
  if (typeof e.GlobalID == "string" && e.GlobalID.trim() !== "")
    return e.GlobalID.trim();
  const n = e.OBJTYPE, t = e.OBJECTID;
  if (typeof n == "string" && n.trim() !== "" && t != null)
    return `${n.trim()}-${t}${ie(r)}`;
}
function ie(e) {
  const r = /_VN(\d+)$/.exec(e ?? "")?.[1];
  return r && r !== "2" ? `@VN${r}` : "";
}
function He(e) {
  const r = C(typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0);
  if (!r)
    return;
  const n = e[r.typeFelt];
  return n == null ? void 0 : String(n);
}
function We(e, r) {
  const n = C(typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0);
  if (!n)
    return;
  const t = r[n.typeFelt];
  return t == null ? void 0 : String(t);
}
function Ue(e) {
  const r = C(typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0);
  if (!r)
    return;
  const n = e[r.headingFelt];
  return n == null ? void 0 : String(n);
}
function ae(e, r, n, t) {
  return {
    omradeId: Je(e, t),
    planId: String(e.PLANID ?? ""),
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    objtype: typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0,
    arealformål: He(e),
    arealformålDisplay: We(e, n),
    feltnavn: Ue(e),
    geometri: r,
    planTypeKey: t,
    attributter: { ...e },
    displayValues: n
  };
}
const Qe = {
  OBJECTID: "objectId",
  planId: "planId",
  pbltiltak: "pblTiltak",
  beskrivelse: "beskrivelse",
  dispensasjonType: "dispensasjonType",
  vedtaksdato: "vedtaksdato",
  tiltaksnr: "tiltaksnr",
  dispFra: "dispFra",
  vedtakId: "vedtakId",
  vedtak: "vedtak",
  sak_id: "sakId",
  sak_sakAar: "sakAar",
  sak_sakSeknr: "sakSeknr",
  sak_arkivId: "sakArkivId",
  sak_url: "sakUrl",
  sak_urlIntern: "sakUrlIntern",
  vedtak_urlEkstern: "vedtakUrlEkstern"
};
function ze(e) {
  const r = {};
  for (const [n, t] of Object.entries(e)) {
    const o = Qe[n];
    r[o ?? n] = t;
  }
  return r;
}
function Xe(e, r, n, t) {
  return {
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    planId: typeof e.planId == "string" ? e.planId : void 0,
    planTypeKey: t,
    pblTiltak: typeof e.pbltiltak == "string" ? e.pbltiltak : void 0,
    beskrivelse: typeof e.beskrivelse == "string" ? e.beskrivelse : void 0,
    dispensasjonType: typeof e.dispensasjonType == "string" ? e.dispensasjonType : void 0,
    vedtaksdato: e.vedtaksdato ?? void 0,
    tiltaksnr: typeof e.tiltaksnr == "string" ? e.tiltaksnr : void 0,
    dispFra: typeof e.dispFra == "string" ? e.dispFra : void 0,
    vedtakId: typeof e.vedtakId == "string" ? e.vedtakId : void 0,
    vedtak: typeof e.vedtak == "string" ? e.vedtak : void 0,
    sakId: typeof e.sak_id == "string" ? e.sak_id : void 0,
    sakAar: e.sak_sakAar ?? void 0,
    sakSeknr: e.sak_sakSeknr ?? void 0,
    sakArkivId: typeof e.sak_arkivId == "string" ? e.sak_arkivId : void 0,
    sakUrl: typeof e.sak_url == "string" ? e.sak_url : void 0,
    sakUrlIntern: typeof e.sak_urlIntern == "string" ? e.sak_urlIntern : void 0,
    vedtakUrlEkstern: typeof e.vedtak_urlEkstern == "string" ? e.vedtak_urlEkstern : void 0,
    geometri: r,
    attributter: { ...e },
    displayValues: ze(n)
  };
}
const Ze = {
  OBJECTID: "objectId",
  PBLTILTAKFORBUDTYPE: "tiltakforbudType",
  INFORMASJON: "informasjon",
  AVGJDATO: "avgjørelsesdato",
  GYLDIGTILDATO: "gyldigTilDato",
  FORSTEDIGITALISERINGSDATO: "førsteDigitaliseringsdato",
  SAKSAR: "saksAar",
  SAKSSEKVENSNUMMER: "saksSekvensnummer"
};
function er(e) {
  const r = {};
  for (const [n, t] of Object.entries(e)) {
    const o = Ze[n];
    r[o ?? n] = t;
  }
  return r;
}
function rr(e, r, n, t) {
  return {
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    planTypeKey: t,
    tiltakforbudType: typeof e.PBLTILTAKFORBUDTYPE == "string" ? e.PBLTILTAKFORBUDTYPE : void 0,
    informasjon: typeof e.INFORMASJON == "string" ? e.INFORMASJON : void 0,
    avgjørelsesdato: e.AVGJDATO ?? void 0,
    gyldigTilDato: e.GYLDIGTILDATO ?? void 0,
    førsteDigitaliseringsdato: e.FORSTEDIGITALISERINGSDATO ?? void 0,
    saksAar: e.SAKSAR ?? void 0,
    saksSekvensnummer: e.SAKSSEKVENSNUMMER ?? void 0,
    geometri: r,
    attributter: { ...e },
    displayValues: er(n)
  };
}
function G(e) {
  const r = /* @__PURE__ */ new Map();
  for (const n of e)
    if (n.domain instanceof Se) {
      const t = /* @__PURE__ */ new Map();
      for (const o of n.domain.codedValues)
        t.set(o.code, o.name);
      r.set(n.name, t);
    }
  return r;
}
function $(e, r) {
  const n = {};
  for (const [t, o] of Object.entries(e)) {
    const a = r.get(t);
    n[t] = a?.get(o) ?? o;
  }
  return n;
}
function be(e) {
  return e.replace(/'/g, "''");
}
function W(e) {
  return `'${be(e)}'`;
}
function Lr(e, r) {
  return r.length === 0 ? "1=0" : `${e} IN (${r.map(W).join(",")})`;
}
const nr = le("arealplan:ServicesInitializer");
function tr() {
  const e = /* @__PURE__ */ new Map(), r = async (a) => {
    try {
      const s = (await pe(a, {
        query: { f: "json" },
        responseType: "json"
      })).data?.layers;
      return s ? s.map((R) => ({
        id: R.id,
        name: R.name,
        url: `${a}/${R.id}`,
        geometryType: R.geometryType
      })) : [];
    } catch (i) {
      throw nr.error(`Feil ved henting av layer-info fra ${a}:`, i), new U(`Kunne ikke laste layer-info: ${i?.message ?? i}`, i);
    }
  }, n = (a) => {
    let i = e.get(a);
    return i || (i = r(a).catch((s) => {
      throw e.delete(a), s;
    }), e.set(a, i)), i;
  };
  return { getLayerInfo: n, getLayerIds: async (a, i) => {
    const s = await n(a);
    if (i && i.length > 0) {
      const R = new Set(i);
      return s.filter((g) => R.has(g.name)).map((g) => g.id);
    }
    return s.filter((R) => R.geometryType === "esriGeometryPolygon").map((R) => R.id);
  }, getLayerMap: async (a) => {
    const i = await n(a);
    return new Map(i.map((s) => [s.name, s]));
  } };
}
const ar = le("arealplan:queryFeatureLayers"), or = 2e3, ir = 1e3, sr = {
  point: "esriGeometryPoint",
  multipoint: "esriGeometryMultipoint",
  polyline: "esriGeometryPolyline",
  polygon: "esriGeometryPolygon",
  extent: "esriGeometryEnvelope"
};
async function K(e, r, n) {
  return r.layerIds.length === 0 ? [] : (await Promise.all(
    r.layerIds.map((o) => lr(e, o, r, n))
  )).filter((o) => o !== null);
}
async function lr(e, r, n, t) {
  const o = {
    where: n.where,
    outSR: n.outputWkid,
    returnGeometry: n.returnGeometry !== !1,
    returnTrueCurves: n.returnTrueCurves ?? !1,
    outFields: n.outFields ? n.outFields.join(",") : "*",
    geometryPrecision: 2,
    f: "json"
  };
  n.geometry && (o.geometryType = sr[n.geometry.type] ?? "esriGeometryPolygon", o.inSR = n.geometry.spatialReference?.wkid ?? n.outputWkid, o.geometry = JSON.stringify(n.geometry.toJSON()), o.spatialRel = "esriSpatialRelIntersects");
  const a = [];
  let i = null, s = 0;
  try {
    for (let g = 0; g < ir; g++) {
      const h = (await pe(`${e}/${r}/query`, {
        query: { ...o, resultOffset: s, resultRecordCount: or },
        method: "post",
        responseType: "json",
        signal: t?.signal
      })).data, B = h?.features ?? [];
      if (g === 0 && (i = h), a.push(...B), h?.exceededTransferLimit !== !0 || B.length === 0)
        break;
      s += B.length;
    }
  } catch (g) {
    throw t?.signal?.aborted || ur(g) ? new Q() : (ar.error(`Feil ved query mot ${e}/${r}:`, g), new U(
      `Query mot ${e}/${r} feilet: ${g?.message ?? g}`,
      g
    ));
  }
  return !i || a.length === 0 ? null : { featureSet: ve.fromJSON({ ...i, features: a }), layerId: r };
}
function ur(e) {
  return typeof e != "object" || e === null ? !1 : e.name === "AbortError";
}
const q = le("arealplan:arcgisArealplanRepository"), L = 25833;
function Y(e) {
  if (e instanceof Q)
    throw e;
}
function dr(e) {
  if (!e.settings)
    throw new z("createArcgisArealplanRepository: settings required");
  const r = e.services ?? tr(), n = () => Object.entries(e.settings.planTypes).filter(([l]) => _e.test(l)).map(([l, y]) => [l, y.url]), t = async (l, y) => {
    const k = n(), m = await Promise.all(
      k.map(async ([d, u]) => {
        try {
          const p = te(d), F = await r.getLayerMap(u);
          let c;
          for (const f of p) {
            const b = F.get(f);
            if (b) {
              c = b;
              break;
            }
          }
          return c ? (await K(
            u,
            {
              layerIds: [c.id],
              where: "1=1",
              geometry: l,
              returnGeometry: !1,
              // `*` i stedet for en eksplisitt feltliste: per-lag
              // endepunktet `/{layerId}/query` validerer outFields
              // strengt og avviser HELE queryen om ett felt mangler
              // på laget («'outFields' parameter is invalid»). Det
              // gamle tjeneste-nivå layerDefs-endepunktet var
              // tolerant her. Mapperen plukker felt by-name
              // (WIRE_TO_DOMAIN_KEY), så ekstra felt er uskadelig.
              outputWkid: L
            },
            y
          )).flatMap(({ featureSet: f }) => {
            const b = G(f.fields ?? []);
            return f.features.map(
              (O) => ce(
                O.attributes,
                d,
                $(O.attributes, b)
              )
            );
          }) : [];
        } catch (p) {
          return Y(p), q.error(`Feil ved henting av planer fra ${d}:`, p), [];
        }
      })
    );
    return ge(m.flat());
  }, o = (l) => t(void 0, l), a = (l, y) => t(l, y), i = async (l, y) => (await Promise.all(
    Object.entries(e.settings.planTypes).map(async ([m, d]) => {
      try {
        const u = te(m);
        if (u.length === 0)
          return [];
        const p = await r.getLayerIds(d.url, u);
        return p.length === 0 ? [] : (await K(
          d.url,
          {
            layerIds: p,
            where: "1=1",
            geometry: l,
            outputWkid: l.spatialReference?.wkid ?? L
          },
          y
        )).map(({ featureSet: c }) => (c.features = c.features.filter(
          (A) => me(l, A.geometry ?? void 0)
        ), { planTypeKey: m, featureSet: c })).filter((c) => c.featureSet.features.length > 0);
      } catch (u) {
        return Y(u), q.error(`Feil ved spatial query for ${m}:`, u), [];
      }
    })
  )).flat(), s = async (l, y) => (await i(l, y)).flatMap((m) => {
    const d = G(m.featureSet.fields ?? []);
    return m.featureSet.features.map(
      (u) => ce(
        u.attributes,
        m.planTypeKey,
        $(u.attributes, d)
      )
    );
  }), R = async (l, y) => {
    const k = l.spatialReference?.wkid ?? L;
    return (await Promise.all(
      Object.entries(e.settings.planTypes).map(async ([d, u]) => {
        try {
          const p = await r.getLayerIds(
            u.url,
            ne
          );
          return p.length === 0 ? [] : (await K(
            u.url,
            {
              layerIds: p,
              where: "1=1",
              geometry: l,
              outputWkid: k
            },
            y
          )).flatMap(({ featureSet: c }) => {
            const A = G(c.fields ?? []);
            return c.features.filter(
              (f) => me(l, f.geometry ?? void 0)
            ).map(
              (f) => ae(
                f.attributes,
                f.geometry ?? void 0,
                $(f.attributes, A),
                d
              )
            );
          });
        } catch (p) {
          return Y(p), q.error(`Feil ved delområde-query for ${d}:`, p), [];
        }
      })
    )).flat();
  }, g = async (l, y) => {
    if (l.length === 0)
      return [];
    const k = [], m = [], d = /* @__PURE__ */ new Map(), u = /^([^:\-@]+)[:-](\d+)(?:@VN(\d+))?$/, p = /^\{?[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\}?$/;
    for (const f of l) {
      const b = u.exec(f);
      if (b) {
        const O = b[1], E = Number(b[2]);
        if (Number.isFinite(E)) {
          const P = b[3] ?? "";
          let T = d.get(P);
          T || (T = /* @__PURE__ */ new Map(), d.set(P, T));
          let j = T.get(O);
          j || (j = [], T.set(O, j)), j.push(E);
          continue;
        }
      }
      if (p.test(f)) {
        m.push(f);
        continue;
      }
      k.push(f);
    }
    const F = [];
    k.length > 0 && F.push(`LOKALID IN (${k.map(W).join(",")})`), m.length > 0 && F.push(`GlobalID IN (${m.map(W).join(",")})`);
    const c = (f) => [...f ?? []].map(
      ([b, O]) => `(OBJTYPE = ${W(b)} AND OBJECTID IN (${O.join(",")}))`
    );
    return (await Promise.all(
      Object.entries(e.settings.planTypes).map(async ([f, b]) => {
        const O = /_VN(\d+)$/.exec(f)?.[1], E = [
          ...F,
          ...c(d.get("")),
          ...O ? c(d.get(O)) : []
        ].join(" OR ");
        if (!E)
          return [];
        try {
          const P = await r.getLayerIds(
            b.url,
            ne
          );
          return P.length === 0 ? [] : (await K(
            b.url,
            {
              layerIds: P,
              where: E,
              outputWkid: L
            },
            y
          )).flatMap(({ featureSet: j }) => {
            const Ae = G(j.fields ?? []);
            return j.features.map(
              (ee) => ae(
                ee.attributes,
                ee.geometry ?? void 0,
                $(ee.attributes, Ae),
                f
              )
            );
          });
        } catch (P) {
          return Y(P), q.error(`Feil ved findDelområderByIds for ${f}:`, P), [];
        }
      })
    )).flat();
  }, D = async (l, y, k, m, d) => {
    const u = e.settings.planTypes[y];
    if (!u)
      return [];
    const p = await r.getLayerIds(u.url, ne);
    if (p.length === 0)
      return [];
    const F = d ?? k?.spatialReference?.wkid ?? L;
    return (await K(
      u.url,
      {
        layerIds: p,
        where: `PLANID = '${be(l)}'`,
        geometry: k,
        outputWkid: F
      },
      m
    )).flatMap(({ featureSet: A }) => {
      const f = G(A.fields ?? []);
      return A.features.filter(
        (b) => ke(k, b.geometry ?? void 0, { minAreaM2: 1 }).keep
      ).map(
        (b) => ae(
          b.attributes,
          b.geometry ?? void 0,
          $(b.attributes, f),
          y
        )
      );
    });
  }, h = async (l, y, k) => {
    const m = e.settings.planTypes[l];
    if (!m || y.length === 0)
      return [];
    const d = te(l), u = await r.getLayerMap(m.url);
    let p;
    for (const c of d) {
      const A = u.get(c);
      if (A) {
        p = A;
        break;
      }
    }
    return p ? (await K(
      m.url,
      {
        layerIds: [p.id],
        where: `OBJECTID IN (${y.map(Number).join(",")})`,
        returnGeometry: !0,
        outFields: ["OBJECTID"],
        outputWkid: L
      },
      k
    )).flatMap(({ featureSet: c }) => c.features).map((c) => c.geometry).filter((c) => c != null) : [];
  }, B = async (l, y) => {
    const k = /* @__PURE__ */ new Map();
    for (const { planTypeKey: d, objectId: u } of x(l)) {
      const p = k.get(d) ?? [];
      p.push(u), k.set(d, p);
    }
    const m = (await Promise.all(
      [...k].map(
        ([d, u]) => h(d, u, y)
      )
    )).flat();
    return m.length <= 1 ? m[0] ?? null : Ee.executeMany(m) ?? null;
  }, _ = async (l, y, k, m, d) => {
    const u = l.spatialReference?.wkid ?? L, p = Object.entries(e.settings.planTypes).filter(
      ([c]) => y.test(c)
    );
    return (await Promise.all(
      p.map(async ([c, A]) => {
        try {
          const b = (await r.getLayerInfo(A.url)).filter((E) => E.geometryType != null).map((E) => E.id);
          return b.length === 0 ? [] : (await K(
            A.url,
            {
              layerIds: b,
              where: "1=1",
              geometry: l,
              outputWkid: u
            },
            d
          )).flatMap(({ featureSet: E }) => {
            const P = G(E.fields ?? []);
            return E.features.map(
              (T) => k(
                T.attributes,
                T.geometry ?? void 0,
                $(T.attributes, P),
                c
              )
            );
          });
        } catch (f) {
          return Y(f), q.error(`Feil ved ${m}-query for ${c}:`, f), [];
        }
      })
    )).flat();
  };
  return {
    findAll: o,
    findByPoint: a,
    findByPolygon: s,
    findFeaturesByPolygon: i,
    findDelområderByPolygon: R,
    findDelområderByIds: g,
    getDelområderForPlan: D,
    getGeometry: B,
    findDispensasjonerByPolygon: (l, y) => _(
      l,
      Ve,
      (k, m, d, u) => Xe(
        k,
        m,
        d,
        u
      ),
      "dispensasjon",
      y
    ),
    findMidlertidigeForbudByPolygon: (l, y) => _(
      l,
      qe,
      (k, m, d, u) => rr(
        k,
        m,
        d,
        u
      ),
      "midlertidig forbud",
      y
    )
  };
}
function mr(e) {
  const { kommunenummer: r, gardsnummer: n, bruksnummer: t, festenummer: o, seksjonsnummer: a } = e;
  if (n == null || t == null)
    return;
  let i = "";
  return r != null && (i += `${r}-`), i += `${n}/${t}`, o && (i += `-${o}`), a && (i += `/${a}`), i;
}
function ye(e, r) {
  return {
    objectId: e.OBJECTID,
    id: String(e.matrikkelid ?? e.OBJECTID),
    kommunenummer: e.kommunenummer != null ? Number(e.kommunenummer) : void 0,
    gardsnummer: e.gardsnummer != null ? Number(e.gardsnummer) : void 0,
    bruksnummer: e.bruksnummer != null ? Number(e.bruksnummer) : void 0,
    festenummer: e.festenummer != null ? Number(e.festenummer) : void 0,
    seksjonsnummer: e.seksjonsnummer != null ? Number(e.seksjonsnummer) : void 0,
    matrikkelId: e.matrikkelid != null ? String(e.matrikkelid) : void 0,
    matrikkelnummerTekst: e.matrikkelnummer ?? mr(e),
    geometri: r
  };
}
function cr(e) {
  if (!e.teigerUrl)
    throw new z("createArcgisTeigRepository: teigerUrl required");
  let r = null;
  const n = () => (r ?? (r = new Pe({ url: e.teigerUrl })), r), t = async (a, i) => {
    try {
      return await a();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? new Q() : new U(`${i} feilet: ${s?.message ?? s}`, s);
    }
  }, o = async (a, i) => t(async () => {
    const s = n().createQuery();
    return s.where = a, s.outFields = ["*"], s.returnGeometry = !0, (await n().queryFeatures(s, { signal: i?.signal })).features.map(
      (g) => ye(
        g.attributes,
        g.geometry
      )
    );
  }, "TeigRepository.query");
  return {
    findByMatrikkel: async (a, i) => {
      const s = [];
      return s.push(`gardsnummer = ${a.gardsnummer}`), s.push(`bruksnummer = ${a.bruksnummer}`), s.push(`kommunenummer = ${a.kommunenummer}`), a.festenummer != null && s.push(`festenummer = ${a.festenummer}`), a.seksjonsnummer != null && s.push(`seksjonsnummer = ${a.seksjonsnummer}`), o(s.join(" AND "), i);
    },
    findByGeometry: async (a, i) => t(async () => {
      const s = n().createQuery();
      return s.geometry = a, s.spatialRelationship = "intersects", s.outFields = ["*"], s.returnGeometry = !0, (await n().queryFeatures(s, { signal: i?.signal })).features.map(
        (g) => ye(
          g.attributes,
          g.geometry
        )
      );
    }, "TeigRepository.findByGeometry")
  };
}
function Mr(e) {
  if (!e.settings)
    throw new z("createArealplanClient: settings required");
  const r = dr({ settings: e.settings }), n = e.settings.teigerUrl ? cr({ teigerUrl: e.settings.teigerUrl }) : void 0;
  return { arealplaner: r, teiger: n };
}
const N = {
  all: ["arealplan"],
  list: () => ["arealplan", "list"],
  byPolygon: (e, r, n, t, o) => ["arealplan", "byPolygon", e, r, n, t, o],
  featuresByPolygon: (e, r, n, t, o) => ["arealplan", "featuresByPolygon", e, r, n, t, o],
  delområder: {
    all: ["arealplan", "delområder"],
    byPolygon: (e, r, n, t, o) => ["arealplan", "delområder", "byPolygon", e, r, n, t, o],
    byIds: (e) => ["arealplan", "delområder", "byIds", [...e].sort().join(",")],
    forPlan: (e, r, n = 0, t = 0, o = 0, a = 0, i = 0) => [
      "arealplan",
      "delområder",
      "forPlan",
      e,
      r,
      n,
      t,
      o,
      a,
      i
    ]
  },
  geometry: (e, r) => [
    "arealplan",
    "geometry",
    e,
    r.map((n) => `${n.planTypeKey}:${n.objectId}`).join(",")
  ],
  teiger: {
    byMatrikkel: (e, r, n, t, o) => ["arealplan", "teiger", "matrikkel", e, r, n, t, o],
    byGeometry: (e, r, n) => ["arealplan", "teiger", "geometry", e, r, n]
  },
  dispensasjoner: {
    byPolygon: (e, r, n, t, o) => ["arealplan", "dispensasjoner", "byPolygon", e, r, n, t, o]
  },
  midlertidigeForbud: {
    byPolygon: (e, r, n, t, o) => ["arealplan", "midlertidigeForbud", "byPolygon", e, r, n, t, o]
  }
};
async function yr(e, r) {
  return e.arealplaner.findAll(r);
}
async function pr(e, r, n) {
  return e.arealplaner.findByPolygon(r.polygon, n);
}
async function fr(e, r, n) {
  return e.arealplaner.findFeaturesByPolygon(r.polygon, n);
}
async function gr(e, r, n) {
  return e.arealplaner.findDelområderByPolygon(r.polygon, n);
}
async function kr(e, r, n) {
  return e.arealplaner.findDelområderByIds(r.omradeIds, n);
}
async function br(e, r, n) {
  const t = typeof r.planTypeKey == "string" ? [r.planTypeKey] : r.planTypeKey;
  return (await Promise.all(
    t.map(
      (a) => e.arealplaner.getDelområderForPlan(
        r.planId,
        a,
        r.polygon,
        n,
        r.outputWkid
      )
    )
  )).flat();
}
async function Rr(e, r, n) {
  return e.arealplaner.getGeometry(r.plan, n);
}
async function Nr(e, r, n) {
  return e.teiger.findByMatrikkel(r, n);
}
async function Ar(e, r, n) {
  return e.teiger.findByGeometry(r.geometry, n);
}
async function Er(e, r, n) {
  return e.arealplaner.findDispensasjonerByPolygon(r.polygon, n);
}
async function Fr(e, r, n) {
  return e.arealplaner.findMidlertidigeForbudByPolygon(r.polygon, n);
}
const H = 5 * 6e4, M = 6e4, Or = (e) => ({
  list: () => I({
    queryKey: N.list(),
    queryFn: ({ signal: r }) => yr(e, { signal: r }),
    staleTime: H
  }),
  byPolygon: (r) => I({
    queryKey: r ? N.byPolygon(
      r.extent?.xmin ?? 0,
      r.extent?.ymin ?? 0,
      r.extent?.xmax ?? 0,
      r.extent?.ymax ?? 0,
      r.spatialReference?.wkid ?? 0
    ) : N.byPolygon(0, 0, 0, 0, 0),
    queryFn: ({ signal: n }) => pr(e, { polygon: r }, { signal: n }),
    enabled: r != null,
    staleTime: M
  }),
  featuresByPolygon: (r) => I({
    queryKey: r ? N.featuresByPolygon(
      r.extent?.xmin ?? 0,
      r.extent?.ymin ?? 0,
      r.extent?.xmax ?? 0,
      r.extent?.ymax ?? 0,
      r.spatialReference?.wkid ?? 0
    ) : N.featuresByPolygon(0, 0, 0, 0, 0),
    queryFn: ({ signal: n }) => fr(e, { polygon: r }, { signal: n }),
    enabled: r != null,
    staleTime: M
  }),
  delområder: {
    byPolygon: (r) => I({
      queryKey: r ? N.delområder.byPolygon(
        r.extent?.xmin ?? 0,
        r.extent?.ymin ?? 0,
        r.extent?.xmax ?? 0,
        r.extent?.ymax ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : N.delområder.byPolygon(0, 0, 0, 0, 0),
      queryFn: ({ signal: n }) => gr(e, { polygon: r }, { signal: n }),
      enabled: r != null,
      staleTime: M
    }),
    byIds: (r) => I({
      queryKey: N.delområder.byIds(r),
      queryFn: ({ signal: n }) => kr(e, { omradeIds: r }, { signal: n }),
      enabled: r.length > 0,
      staleTime: M
    }),
    /**
     * `planTypeKey` kan være en liste når planen ligger på flere
     * vertikalnivåer (én FeatureServer per nivå) — da hentes delområdene
     * fra alle og slås sammen.
     */
    forPlan: (r, n, t, o) => {
      const a = n == null ? [] : typeof n == "string" ? [n] : n;
      return I({
        // outputWkid MÅ inn i nøkkelen — uten polygon skiller den ellers
        // ikke 25832- fra 25833-resultater, og cachen ville servert feil-SR
        // geometri til kart-rendering.
        queryKey: t ? N.delområder.forPlan(
          r ?? "",
          a.join(","),
          t.extent?.xmin ?? 0,
          t.extent?.ymin ?? 0,
          t.extent?.xmax ?? 0,
          t.extent?.ymax ?? 0,
          t.spatialReference?.wkid ?? 0
        ) : N.delområder.forPlan(
          r ?? "",
          a.join(","),
          0,
          0,
          0,
          0,
          o ?? 0
        ),
        queryFn: ({ signal: i }) => br(
          e,
          {
            planId: r,
            planTypeKey: a,
            polygon: t ?? void 0,
            outputWkid: o
          },
          { signal: i }
        ),
        enabled: !!(r && a.length > 0),
        staleTime: M
      });
    }
  },
  geometry: (r) => I({
    queryKey: r ? N.geometry(r.planId, x(r)) : N.geometry("", []),
    queryFn: ({ signal: n }) => Rr(e, { plan: r }, { signal: n }),
    enabled: r != null,
    staleTime: H
  }),
  dispensasjoner: {
    byPolygon: (r) => I({
      queryKey: r ? N.dispensasjoner.byPolygon(
        r.extent?.xmin ?? 0,
        r.extent?.ymin ?? 0,
        r.extent?.xmax ?? 0,
        r.extent?.ymax ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : N.dispensasjoner.byPolygon(0, 0, 0, 0, 0),
      queryFn: ({ signal: n }) => Er(e, { polygon: r }, { signal: n }),
      enabled: r != null,
      staleTime: M
    })
  },
  midlertidigeForbud: {
    byPolygon: (r) => I({
      queryKey: r ? N.midlertidigeForbud.byPolygon(
        r.extent?.xmin ?? 0,
        r.extent?.ymin ?? 0,
        r.extent?.xmax ?? 0,
        r.extent?.ymax ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : N.midlertidigeForbud.byPolygon(0, 0, 0, 0, 0),
      queryFn: ({ signal: n }) => Fr(e, { polygon: r }, { signal: n }),
      enabled: r != null,
      staleTime: M
    })
  },
  teiger: {
    byMatrikkel: (r) => I({
      queryKey: N.teiger.byMatrikkel(
        r?.kommunenummer ?? 0,
        r?.gardsnummer ?? 0,
        r?.bruksnummer ?? 0,
        r?.festenummer ?? 0,
        r?.seksjonsnummer ?? 0
      ),
      queryFn: ({ signal: n }) => {
        if (!e.teiger)
          throw new Error("TeigRepository not configured");
        return Nr(
          { teiger: e.teiger },
          r,
          { signal: n }
        );
      },
      enabled: r != null && e.teiger != null,
      staleTime: H
    }),
    byGeometry: (r) => I({
      queryKey: r ? N.teiger.byGeometry(
        r.x ?? 0,
        r.y ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : N.teiger.byGeometry(0, 0, 0),
      queryFn: ({ signal: n }) => {
        if (!e.teiger)
          throw new Error("TeigRepository not configured");
        return Ar(
          { teiger: e.teiger },
          { geometry: r },
          { signal: n }
        );
      },
      enabled: r != null && e.teiger != null,
      staleTime: H
    })
  }
});
function se(e, r) {
  if (e.attributter[r] != null)
    return e.attributter[r];
  const n = r.toLowerCase();
  for (const [t, o] of Object.entries(e.attributter))
    if (t.toLowerCase() === n && o != null)
      return o;
}
function Re(e, r) {
  return se(e, r) ?? e.displayValues[r];
}
function Ne(e) {
  return Array.from(
    new Set(
      e.filter((r) => r != null).map((r) => String(r).trim()).filter(Boolean)
    )
  );
}
function wr(e) {
  if (e.arealformål)
    return [e.arealformål];
  const r = C(e.objtype);
  if (!r)
    return [];
  const n = Re(e, r.typeFelt);
  return Ne([n]);
}
function Dr(e) {
  const r = C(e.objtype), n = r ? Re(e, r.headingFelt) : void 0, t = e.objtype, o = e.objectId, a = se(e, "GlobalID"), i = se(e, "LOKALID"), s = a == null ? void 0 : String(a).replace(/[{}]/g, "").trim(), R = [
    n,
    i,
    a,
    s,
    s ? s.toLowerCase() : void 0,
    s ? s.toUpperCase() : void 0,
    s ? `{${s}}` : void 0,
    s ? `{${s.toUpperCase()}}` : void 0,
    o,
    t && o ? `${t}-${o}` : void 0,
    t && o && ie(e.planTypeKey) ? `${t}-${o}${ie(e.planTypeKey)}` : void 0,
    o ? `undefined-${o}` : void 0
  ];
  return Ne(R);
}
const X = he(null), Gr = ({
  client: e,
  children: r
}) => {
  const n = Be(
    () => ({
      client: e,
      queries: Or({
        arealplaner: e.arealplaner,
        teiger: e.teiger
      })
    }),
    [e]
  );
  return /* @__PURE__ */ Te(X.Provider, { value: n, children: r });
};
function $r() {
  const e = ue(X);
  if (!e)
    throw new Error("useArealplanClient må brukes innenfor en <ArealplanClientProvider>");
  return e.client;
}
function xr() {
  return ue(X)?.client ?? null;
}
function v() {
  const e = ue(X);
  if (!e)
    throw new Error("useArealplanQueries må brukes innenfor en <ArealplanClientProvider>");
  return e.queries;
}
function _r() {
  const e = v();
  return S(e.list());
}
function Vr(e) {
  const r = v();
  return S(r.byPolygon(e));
}
function qr(e) {
  const r = v();
  return S(r.featuresByPolygon(e));
}
function Yr(e) {
  const r = v();
  return S(r.geometry(e));
}
function Cr(e) {
  const r = v();
  return S(r.dispensasjoner.byPolygon(e));
}
function Jr(e) {
  const r = v();
  return S(r.midlertidigeForbud.byPolygon(e));
}
function Hr(e) {
  const r = v();
  return S(r.delområder.byPolygon(e));
}
function Wr(e) {
  const r = v();
  return S(r.delområder.byIds(e));
}
function Ur(e, r, n, t) {
  const o = v();
  return S(o.delområder.forPlan(e, r, n, t));
}
function Qr(e) {
  const r = v();
  return S(r.teiger.byMatrikkel(e));
}
function zr(e) {
  const r = v();
  return S(r.teiger.byGeometry(e));
}
class Xr {
  constructor(r = {}) {
    this.data = r;
  }
  async findAll() {
    return [...this.data.arealplaner ?? []];
  }
  async findByPoint() {
    return [...this.data.arealplaner ?? []];
  }
  async findByPolygon() {
    return [...this.data.arealplaner ?? []];
  }
  async findFeaturesByPolygon() {
    return [];
  }
  async findDelområderByPolygon() {
    return [...this.data.delområder ?? []];
  }
  async findDelområderByIds(r) {
    const n = new Set(r);
    return (this.data.delområder ?? []).filter((t) => t.omradeId && n.has(t.omradeId));
  }
  async getDelområderForPlan(r) {
    return (this.data.delområder ?? []).filter((n) => n.planId === r);
  }
  async getGeometry() {
    return null;
  }
  async findDispensasjonerByPolygon() {
    return [...this.data.dispensasjoner ?? []];
  }
  async findMidlertidigeForbudByPolygon() {
    return [...this.data.midlertidigeForbud ?? []];
  }
}
class Zr {
  constructor(r = []) {
    this.teiger = r;
  }
  async findByMatrikkel(r) {
    return this.teiger.filter(
      (n) => n.kommunenummer === r.kommunenummer && n.gardsnummer === r.gardsnummer && n.bruksnummer === r.bruksnummer && (r.festenummer == null || n.festenummer === r.festenummer) && (r.seksjonsnummer == null || n.seksjonsnummer === r.seksjonsnummer)
    );
  }
  async findByGeometry() {
    return [...this.teiger];
  }
}
export {
  ne as ALL_DELOMRADE_SUBLAYER_NAMES,
  Q as AbortedError,
  Gr as ArealplanClientProvider,
  w as ArealplanError,
  xe as AuthError,
  z as ConfigurationError,
  Xr as FakeArealplanRepository,
  Zr as FakeTeigRepository,
  U as NetworkError,
  Ge as NotFoundError,
  oe as OBJTYPE_REGISTRY,
  $e as ValidationError,
  ce as arealplanFromAttrs,
  N as arealplanKeys,
  Or as arealplanQueries,
  G as buildFieldLookup,
  Lr as buildInClause,
  dr as createArcgisArealplanRepository,
  cr as createArcgisTeigRepository,
  Mr as createArealplanClient,
  ae as delområdeFromFeature,
  Xe as dispensasjonFromFeature,
  Kr as domain,
  be as escapeSqlValue,
  fr as findArealplanFeaturesByPolygon,
  pr as findArealplanerByPolygon,
  kr as findDelområderByIds,
  gr as findDelområderByPolygon,
  Er as findDispensasjonerByPolygon,
  Fr as findMidlertidigeForbudByPolygon,
  C as findObjtypeInfo,
  Ar as findTeigByGeometry,
  Nr as findTeigByMatrikkel,
  wr as getArealformålCandidates,
  Rr as getArealplanGeometry,
  Dr as getOmrådeIdCandidates,
  te as getPlanomradeLagnavn,
  yr as loadAlleArealplaner,
  br as loadDelområderForArealplan,
  $ as mapDisplayValues,
  ge as mergePlanomrader,
  rr as midlertidigForbudFromFeature,
  De as planKey,
  je as planTypeKeysFor,
  x as planomraderFor,
  W as qv,
  ye as teigFromAttrs,
  $r as useArealplanClient,
  xr as useArealplanClientOptional,
  qr as useArealplanFeaturesByPolygon,
  Yr as useArealplanGeometry,
  _r as useArealplaner,
  Vr as useArealplanerByPolygon,
  Wr as useDelområderByIds,
  Hr as useDelområderByPolygon,
  Ur as useDelområderForArealplan,
  Cr as useDispensasjonerByPolygon,
  Jr as useMidlertidigeForbudByPolygon,
  zr as useTeigByGeometry,
  Qr as useTeigByMatrikkel
};
//# sourceMappingURL=index.mjs.map
